import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import type { BaseFile } from 'config'
import { openS3Document } from 'services'

interface FileLinksProps {
  files?: BaseFile[]
}

export const FileLinks = ({ files }: FileLinksProps) => {
  if (!files || files.length === 0) return null

  return (
    <div className="flex flex-wrap gap-x-3 gap-y-0.5">
      {files.map((file, index) => (
        <span
          key={file.id || index}
          className="text-[12px] text-shade-blue hover:underline flex items-center gap-1 cursor-pointer"
          onClick={() => openS3Document(file.fileKey)}
          title={file.name}
        >
          <ArrowDownTrayIcon className="w-3 h-3 flex-shrink-0" />
          <span className="truncate max-w-[200px]">{file.name}</span>
        </span>
      ))}
    </div>
  )
}
